__turbopack_context__.v({
  "copyrightAndLegal": "Footer-module-scss-module__2Z8NfG__copyrightAndLegal",
  "copyrightWithLegalLinks": "Footer-module-scss-module__2Z8NfG__copyrightWithLegalLinks",
  "ctc": "Footer-module-scss-module__2Z8NfG__ctc",
  "ctcInfo": "Footer-module-scss-module__2Z8NfG__ctcInfo",
  "ctcLink": "Footer-module-scss-module__2Z8NfG__ctcLink",
  "ctcLogo": "Footer-module-scss-module__2Z8NfG__ctcLogo",
  "disclaimer": "Footer-module-scss-module__2Z8NfG__disclaimer",
  "fade-in": "Footer-module-scss-module__2Z8NfG__fade-in",
  "legal": "Footer-module-scss-module__2Z8NfG__legal",
  "legalLink": "Footer-module-scss-module__2Z8NfG__legalLink",
  "legalLinks": "Footer-module-scss-module__2Z8NfG__legalLinks",
  "linkGroups": "Footer-module-scss-module__2Z8NfG__linkGroups",
  "logo": "Footer-module-scss-module__2Z8NfG__logo",
  "logoAndLinkGroups": "Footer-module-scss-module__2Z8NfG__logoAndLinkGroups",
  "logoLink": "Footer-module-scss-module__2Z8NfG__logoLink",
  "privacyPreferences": "Footer-module-scss-module__2Z8NfG__privacyPreferences",
  "root": "Footer-module-scss-module__2Z8NfG__root",
  "signUp": "Footer-module-scss-module__2Z8NfG__signUp",
  "tagline": "Footer-module-scss-module__2Z8NfG__tagline",
});
